/**
 * Metadata of a file picked for analysis (pure; used for analytics events
 * and the upload payload).
 */

/** Lower-cased extension of a filename, or undefined when it has none. */
export function getFileExtension(name?: string): string | undefined {
  if (!name) return undefined;
  const parts = name.split('.');
  if (parts.length < 2) return undefined;
  return parts.pop()?.toLowerCase();
}

/** MIME type from the picker asset (`mimeType`) or a web File (`type`). */
export function getAnalysisFileMimeType(file?: any): string {
  return file?.mimeType || file?.type || 'application/octet-stream';
}
